// extracted by mini-css-extract-plugin
export default {"signInLayout":"SignInLayout_signInLayout__xNy6r","signInPage":"SignInLayout_signInPage__6E52q"};